/* eslint-disable no-undef */
function acSlider() {
  if ($('#ac-slider').length) {
    if (!$('#ac-slider').hasClass('splide-initialized')) {
      new Splide('#ac-slider', {
        perPage: 6,
        pagination: false,
        arrows: false,
        autoHeight: true,
        speed: 2000,
        drag: false,
        easing: 'ease',
        breakpoints: {
          320: {
            perPage: 1,
            drag: true,
          },
          992: {
            perPage: 2,
            drag: true,
            padding: { right: '20%' },
          },
          1200: {
            perPage: 4,
            drag: true,
            padding: { right: '20%' },
          },
        },
      }).mount();
    }
  }
}

export default acSlider;